import * as React from "react";
import * as ReactDOM from "react-dom";
import classnames from "classnames";
import * as styles from "./styles.scss";
import { Switch } from "../../../../components";

interface ICheckboxProps {
  value: any;
}

const renderCheckbox = (props: any) => (
  <div className={styles.option} key={props.option.id}>
    <div
      className={classnames({
        [styles.image]: true,
        [styles.active]: props.isChecked
      })}
      style={{ backgroundImage: `url(${props.option.src})` }}
    />
  </div>
);

export const CheckboxImg = ({ value }: ICheckboxProps) => (
  <div className={styles.checkbox}>{value.map(renderCheckbox)}</div>
);
